export default "__VITE_ASSET__DyrG$$1E__"